import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/BITCOINCOM_LOGO.svg");
;
import(/* webpackMode: "eager" */ "/app/public/COINDESK_LOGO.svg");
;
import(/* webpackMode: "eager" */ "/app/public/CT_LOGO.svg");
;
import(/* webpackMode: "eager" */ "/app/public/jars_img.png");
;
import(/* webpackMode: "eager" */ "/app/public/lock_glass.png");
;
import(/* webpackMode: "eager" */ "/app/public/mia_crosschain_icon.png");
;
import(/* webpackMode: "eager" */ "/app/public/mia_fraud_prevention_icon.png");
;
import(/* webpackMode: "eager" */ "/app/public/mia_health_icon.png");
;
import(/* webpackMode: "eager" */ "/app/public/mia_onboarding_icon.png");
;
import(/* webpackMode: "eager" */ "/app/public/mia_phones.png");
;
import(/* webpackMode: "eager" */ "/app/public/mia_trading_icon.png");
;
import(/* webpackMode: "eager" */ "/app/public/MIA.png");
;
import(/* webpackMode: "eager" */ "/app/public/near_ai_logo.svg");
;
import(/* webpackMode: "eager" */ "/app/public/onramps_header_flat.png");
;
import(/* webpackMode: "eager" */ "/app/public/onramps_header.png");
;
import(/* webpackMode: "eager" */ "/app/public/rewards.png");
;
import(/* webpackMode: "eager" */ "/app/public/run_icon_green.png");
;
import(/* webpackMode: "eager" */ "/app/public/sweat_icon_round.png");
;
import(/* webpackMode: "eager" */ "/app/public/sweat_icon_square.png");
;
import(/* webpackMode: "eager" */ "/app/public/wallets_created_logo.svg");
;
import(/* webpackMode: "eager" */ "/app/public/wheel.png");
;
import(/* webpackMode: "eager", webpackExports: ["default","PlainAppStoreButton"] */ "/app/src/app/shared/components/AppStoreButton/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/ContextualLink/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/Button/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/EarnSimulator/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/InstallSection/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/PageSection/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/Label/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/wallet/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/Scene/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/TokensCarousel/index.tsx");
